var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "close-after-sales" }, [
    _c("div", { staticClass: "close-after-sales-content" }, [
      _c("div", { staticClass: "close-sales-title" }, [
        _c("div", { staticClass: "medium" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.message.userKey === "Platform"
                  ? "Platform"
                  : _vm.message.username
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.message.createAt))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "close-sales-content" }, [
        _c("div", [_vm._v("Service order is closed")]),
        _vm._v(" "),
        _vm.message.status !== 34
          ? _c("div", [
              _vm.message.userKey === "Platform"
                ? _c("span", [_vm._v("The brand refuses Service Order")])
                : _vm.message.userKey
                ? _c("span", [_vm._v("The Retailer cancels after-sale order")])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.message.status === 34
          ? _c("div", [
              _vm._v(
                "\n        The platfrom (ShopVidi) Arbitration has closed Service Order\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.serviceOrder["userId"] != _vm.message.userKey
          ? _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.message.userKey ? "Arbitration reason:" : "") +
                  " " +
                  _vm._s(_vm.message.reason) +
                  "\n      "
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-738f3319", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738f3319","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/history-list/close-after-sales.vue
// module id = eulk
// module chunks = 2